export default {
    organisationBaseData: 'Unternehmen'
}
